<template>
  <TextField
    id="mealplan-vendor-id"
    name="keystore.vendor_id"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.vendorId')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.vendorIdPlaceholder')"
    :disabled="!editMealPlan"
    :required="editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
